/* Veyra · «Llega gratis» con fecha estimada · 2026-10-09
   Pinta en cada [data-vy-llega] el rango de entrega del envío estándar según la
   política publicada: de 3 a 5 días NATURALES (cuentan sábados, domingos y
   feriados). Lo de «se procesa en 2 h» es dato interno y no se usa aquí.

   Atributos opcionales:
     data-min="3" data-max="5"   días naturales (por defecto, la política)
     data-formato="larga"        «12–14 de octubre» (por defecto)
     data-formato="corta"        «12–14 oct»
   Si el script no corre, el HTML ya trae su texto de respaldo
   («en 3 a 5 días»): nunca se queda vacío. */
(function () {
  var MES = ['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'];
  var MES_C = ['ene','feb','mar','abr','may','jun','jul','ago','sep','oct','nov','dic'];

  function sumarDias(desde, n) {
    return new Date(desde.getFullYear(), desde.getMonth(), desde.getDate() + n);
  }
  function texto(a, b, corta) {
    var M = corta ? MES_C : MES;
    if (a.getMonth() === b.getMonth()) return a.getDate() + '–' + b.getDate() + (corta ? ' ' : ' de ') + M[b.getMonth()];
    return a.getDate() + ' ' + MES_C[a.getMonth()] + ' – ' + b.getDate() + ' ' + MES_C[b.getMonth()];
  }
  function pintar(raiz) {
    var hoy = new Date();
    Array.prototype.forEach.call((raiz || document).querySelectorAll('[data-vy-llega]'), function (el) {
      var min = parseInt(el.getAttribute('data-min') || '3', 10), max = parseInt(el.getAttribute('data-max') || '5', 10);
      el.textContent = texto(sumarDias(hoy, min), sumarDias(hoy, max), el.getAttribute('data-formato') === 'corta');
    });
  }
  window.vyLlega = pintar;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { pintar(); });
  else pintar();
  /* El carrito se vuelve a pintar por AJAX: repinta cuando cambie */
  document.addEventListener('vy:carrito-pintado', function () { pintar(); });
})();
